import AnalyticsRecord, { AnalyticsRecordSource } from './AnalyticsRecord.js';

/**
 * @property {number} id
 * @property {date} occurrence
 * @property {object} user
 * @property {string} event
 * @property {object} eventData
 */
class UserEvent extends AnalyticsRecord {}
UserEvent.$AR = {
  SourceClass: AnalyticsRecordSource,
};

export default UserEvent;
